export enum ErrorType {
  General = 0,
  Infrastructure = 1
}
